import { ButtonLink } from '@klokgroep/shared-components/src/Button';
import { GetBlogPostsResponse, HoldingNewsPageResponse } from '@klokgroep/sanity';
import { NewsletterAdditionalDataPopup, NewsletterSubscriptionTile } from '@klokgroep/shared-components/src/Newsletter';
import { RichText } from '@klokgroep/shared-components/src/RichText';
import { TitleOverTwoRules } from '@klokgroep/shared-components/src/TitleOverTwoRules';
import styles from './BlogsContainer.module.css';
import { PagePreviewItem } from '@klokgroep/shared-components/src/PagePreviewItem';
import { BlockContainerWithBackgroundProperties } from '@klokgroep/shared-components/src/BlockContainerWithBackground';
import { useState, useCallback, Fragment } from 'react';
import { useCommonTranslations } from '@klokgroep/shared-components/utils/useTranslations';

interface BlogsContainerProperties {
  items?: GetBlogPostsResponse[];
  readMoreHref?: string;
  backgroundColor?: BlockContainerWithBackgroundProperties['backgroundColor'];
  title: string;
  newsletterSubscriptionBlock?: HoldingNewsPageResponse['newsletterSubscriptionBlock'];
}

export const BlogsContainer = ({
  items,
  readMoreHref,
  title,
  backgroundColor,
  newsletterSubscriptionBlock,
}: BlogsContainerProperties) => {
  const t = useCommonTranslations();

  const [showAdditionalInfoPopup, setShowAdditionalInfoPopup] = useState(true);
  const [subscriberId, setSubscriberId] = useState();

  const onClose = useCallback(() => {
    setShowAdditionalInfoPopup(false);
  }, []);

  return (
    <div>
      <div className={styles.container}>
        <RichText>
          <TitleOverTwoRules as="h2">{title}</TitleOverTwoRules>
        </RichText>

        {items?.map(({ slug, previewText, blogHero, categories, link, ...rest }, index) => (
          <Fragment key={slug?.current}>
            {index === (readMoreHref ? items.length - 1 : 1) ? (
              <NewsletterSubscriptionTile
                setSubscriberId={setSubscriberId}
                title={newsletterSubscriptionBlock?.title}
                imageAsset={newsletterSubscriptionBlock?.newsletterBackgroundImage}
                subtitle={newsletterSubscriptionBlock?.subtitle}
              />
            ) : undefined}
            <PagePreviewItem
              title={blogHero?.title}
              link={link}
              backgroundColor={backgroundColor}
              imageAsset={blogHero?.images ? blogHero.images[0] : undefined}
              previewText={previewText || blogHero?.intro}
              category={categories ? categories[0] : undefined}
              {...rest}
            />
          </Fragment>
        ))}
      </div>
      {readMoreHref ? (
        <div className={styles.buttonContainer}>
          <ButtonLink href={readMoreHref}>{t('blog_grid_read_more_button_label')}</ButtonLink>
        </div>
      ) : undefined}
      {showAdditionalInfoPopup && subscriberId ? (
        <NewsletterAdditionalDataPopup subscriberId={subscriberId} onClose={onClose} />
      ) : undefined}
    </div>
  );
};
